import React from 'react';
export function WarpRing() {
  return <div className="relative w-[300px] h-[300px] md:w-[500px] md:h-[500px] flex items-center justify-center" data-id="element-281">
      {/* Core Black Hole */}
      <div className="absolute w-32 h-32 md:w-48 md:h-48 bg-black rounded-full shadow-[0_0_60px_rgba(0,201,167,0.6)] z-20" data-id="element-282"></div>

      {/* Event Horizon Glow */}
      <div className="absolute w-36 h-36 md:w-52 md:h-52 rounded-full bg-gradient-to-r from-[#1a4fd6] to-[#00f5a0] opacity-80 blur-md z-10 animate-pulse-glow" data-id="element-283"></div>

      {/* Inner Accretion Disk */}
      <div className="absolute w-full h-full rounded-full border-[1px] border-transparent border-t-[#00f5a0] border-r-[#00c9a7] opacity-60 animate-spin-slow blur-[1px]" data-id="element-284"></div>

      {/* Outer Accretion Disk */}
      <div className="absolute w-[120%] h-[120%] rounded-full border-[2px] border-transparent border-b-[#1a4fd6] border-l-[#00c9a7] opacity-40 animate-spin-reverse-slow blur-[2px]" data-id="element-285"></div>

      {/* Warp Lines / Distortion Field */}
      <div className="absolute w-[150%] h-[150%] rounded-full border border-white/5 animate-spin-slow opacity-20" data-id="element-286"></div>
      <div className="absolute w-[80%] h-[80%] rounded-full border border-white/10 animate-spin-reverse-slow opacity-30" data-id="element-287"></div>

      {/* Particles */}
      <div className="absolute top-0 left-1/2 w-2 h-2 bg-[#00f5a0] rounded-full blur-[2px] animate-float" data-id="element-288"></div>
      <div className="absolute bottom-10 right-10 w-1 h-1 bg-[#1a4fd6] rounded-full blur-[1px] animate-pulse" data-id="element-289"></div>
    </div>;
}